<template>

   <div class="container">
                <div class="page-header">
                    <div class="page-title">
                  
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                 <li>
                                  <router-link :title="'الرئيسية'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسية</router-link>
                                </li>
                                 <li class="active">
                                  <router-link :title="'الملف الشخصي'" :to="{name: 'roles.create'}">الملف الشخصي</router-link>
                                </li>
                            </ul>
                        </div> 
                    </div> 
                </div>
                

                <div class="row">

                    <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12  layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">                                
                                <div class="row">
                                    <div class="col-xl-12 col-md-12 col-sm-12 col-12">
                                      
                                        <h4>
                                            <i class="flaticon-computer-4"></i> 
                                          الملف الشخصي</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                <form @submit.prevent="store()">
                                                                          <div class="row">
                                         <div class="col-md-4">
                                              <label for="exampleFormControlInput12">الاسم</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>
                                       
                                        <input type="text" class="form-control" id="exampleFormControlInput1211" v-model="data.form.name" placeholder="الاسم">
                                         <div class="invalid-feedback" :style="getErrors['name'] ? 'display: block' : 'display: none;'"   v-if="getErrors['name']">
                                              {{ getErrors['name'][0] }}
                                        </div>
                                    </div>
                                       </div>

                                        <div class="col-md-4"  v-if="user.role == 'parent'">
                                                  <label for="exampleFormControlInput12">رقم الجوال</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-telephone"></i></span>
                                      </div>

          
                                      
                                        <input type="text" class="form-control" id="exampleFormControlInput12" v-model="data.form.mobile" placeholder="الاسم">
                                         <div class="invalid-feedback" :style="getErrors['mobile'] ? 'display: block' : 'display: none;'"   v-if="getErrors['mobile']">
                                              {{ getErrors['mobile'][0] }}
                                        </div>
                                    </div>
                                     </div>

 <div class="col-md-4" v-else>
                                                <label for="exampleFormControlInput1">البريد الإلكتروني</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-email"></i></span>
                                      </div>

                                        <input type="email" class="form-control" id="exampleFormControlInput212" v-model="data.form.email" placeholder="البريد الالكترونى">
                                         <div class="invalid-feedback" :style="getErrors['email'] ? 'display: block' : 'display: none;'"   v-if="getErrors['email']">
                                              {{ getErrors['email'][0] }}
                                        </div>
                                    </div>
                                      </div>

                                     <div class="col-md-4">
                                                                         
                                        <label for="exampleFormControlInput3">كلمة المرور</label>
                                  <div class="input-group mb-4">
                                      
                                      <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1"><i class="flaticon-file"></i></span>
                                      </div>

                                        <input type="password" class="form-control" id="exampleFormControlInput12" v-model="data.form.password" placeholder="كلمة المرور">
                                         <div class="invalid-feedback" :style="getErrors['password'] ? 'display: block' : 'display: none;'"   v-if="getErrors['password']">
                                              {{ getErrors['password'][0] }}
                                        </div>
                                    </div>
                                     </div>
                                     </div>
                                    <!-- <input type="submit" name="time" class="mt-4 mb-4 btn btn-button-7" value="حفظ"> -->
                                    <button type="submit"  name="time" value="حفظ" class="save-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>حفظ</span></button>
                                    <button type="button" @click.prevent="resetForm" class="rewrite-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p"><span>تفريغ</span></button>
                                    <router-link class="back-btn btn-creative btn-3 btn-3a flaticon-cart-fill" fdprocessedid="6b18p" :to="{name: 'dashboard'}">
                                      <span>رجوع</span>
                                    </router-link>


                                </form>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

</template>
<script>
import router from '@/router'

export default {
  data() {
    return {
      trans: {},
      data: {
        checkerExit: 0,
        form: {
          name: '',
          password: '',
        },
        isRequested: false,
        errors: {},
        paginated: {},
      }
    };
  },
  created() {
    this.data.form.name = this.user.name;

    if(this.user.role == 'parent'){
      this.data.form.mobile = this.user.mobile;
    }else{
      this.data.form.email = this.user.email;
    }

  },
  methods: {
    resetForm(){
      if(this.user.role == 'parent'){
        this.data.form = {
          name: '',
          password: '',
          mobile: ''
        }
      }else{
        this.data.form = {
          name: '',
          password: '',
          email: ''
        }
      }
    },
    store(){
      this.data.isRequested = true;
      let url = '';
      if(this.user.role == 'parent'){
        url = 'parent-update-me';
      }else if(this.user.role == 'teacher'){
        url = 'teacher-update-me';
      }else{
        url = 'update-me';
      }
      this.$baseApi.post(url, this.data.form).then((response) => {
     
        if (response.data.code === 200) {
          this.sweetAlert(response.data.messages[0]);
        }
      }).catch((error) => {
        this.data.errors = JSON.parse(JSON.stringify(error.response.data.errors));
        this.data.isRequested = false
      })
    },
   
  },
  computed: {
    getErrors() {
      return JSON.parse(JSON.stringify(this.data.errors))
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  }
};
</script>
<style>
.role-box {
  border-radius: 6px;
  box-shadow: 1px 1px 4px 0 #0000004a;
  padding: 11px;
}

.role-box h5 {
  text-align: center;
  border-bottom: 1px solid #8080808c;
}

.role-selected {
  border-radius: 6px;
  box-shadow: 0 2px 2px 0 #00000042;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding: 11px;
}
</style>
